import {HttpClient} from '@angular/common/http';
import {Component, computed, effect, forwardRef, input, OnInit, output, signal, WritableSignal} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {compareEntity} from "../../../features/utils/functions.utils";


// FIXME: SANTIAGO  optionLabel="description" > DEBE ESSERE GENERICO

@Component({
  selector: 'app-default-select',
  template: `
      @if(label()){
      <label for="select_input" class="font-semibold">{{label()}} </label>
      }
      @if(hasItems()){
      <p-dropdown id="select_input"
                  [options]="items()"
                  [optionLabel]="optionLabel()"
                  [disabled]="isDisabled()"
                  [optionDisabled]="optionDisabled()"
                  [showClear]="clearable()"
                  [(ngModel)]="selectedValue" [placeholder]="'default.input.select.placeholder' | transloco"
          (onChange)="onSelect($event.value)" [appendTo]="appendTo()">
      </p-dropdown>
      } @else {
        loading ...
      }
  `,
  styleUrl: './default-select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DefaultSelectComponent),
      multi: true,
    },
  ],
})
export class DefaultSelectComponent<T> implements OnInit, ControlValueAccessor {
  optionLabel = input<string>("description");
  optionDisabled = input<string>("obsolete");
  isDisabled : WritableSignal<boolean> = signal(false);
  clearable = input<boolean>(false);
  apiEndpoint = input<string>();
  manualOptions = input<T[]>();
  label = input<string>('');
  appendTo=input<string>('body');
  //ATTENZIONE PDropdown non utilizza compareWith
  compareWith = input<(a: any, b: any) => boolean>(compareEntity);


  isOptionDisabled(option?: any) {
    return option?.obsolete ?? option?.disabled ?? false;
  }
  itemSelected = output<T>();
  items:WritableSignal<T[]> = signal([]);
  hasItems = computed(() => this.items()?.length > 0);
  selectedValue: T | null = null;
  private urlBase = environment.apiUrl;


  private onChange: (value: T | null) => void = () => { };
  private onTouched: () => void = () => { };
  setDisabledState?(isDisabled: boolean): void {
    queueMicrotask(() =>  this.isDisabled.set(isDisabled));
  }
  constructor(private http: HttpClient) {
    effect(() => {
      if (this.manualOptions()) {
        console.log("setting items", this.manualOptions());
        queueMicrotask(() => this.items.set(this.manualOptions() || []));
      } else if (this.apiEndpoint()) {
        this.fetchData();
      }
    });

    effect(() => {
      if(this.hasItems()){
        if(this.selectedValue) {
          const itemInList = this.items().find(i => this.compareWith()(i, this.selectedValue));
          if (itemInList) {
            this.selectedValue = itemInList;
          } else {
            this.items.update(items => [...items, this.selectedValue!]);
          }
        }
      }
    });
  }

  ngOnInit(): void {


  }

  fetchData() {
    this.http.get<{ items: T[] }>(`${this.urlBase}${this.apiEndpoint()}`).subscribe((res) => {
      this.items.set(res.items);
    });
  }

  onSelect(value: T) {
    this.selectedValue = value;
    this.onChange(value);
    this.onTouched();
    this.itemSelected.emit(value);
  }

  writeValue(value: T | null): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: (value: T | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

}
